
import { FSharpRef, Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { option_type, bool_type, float64_type, record_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import * as xlsx from "xlsx";
import { item, length, isEmpty, empty, singleton, map, iterate, ofArray, choose } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { min, max } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import jsbarcode from "jsbarcode";
import qrcode from "qrcode";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { int32ToString, defaultOf, stringHash } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { tryGetValue } from "../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { map as map_1, delay, toList, tryFindIndex } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { isDigit } from "../fable_modules/fable-library-js.5.0.0-rc.2/Char.js";
import { tryParse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Int32.js";
import { padLeft } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { jsPDF } from "jspdf";

export class CodeType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["QRCode", "Barcode"];
    }
}

export function CodeType_$reflection() {
    return union_type("LabelPrint.PdfGenerator.CodeType", [], CodeType, () => [[], []]);
}

export class LogoCorner extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
    }
}

export function LogoCorner_$reflection() {
    return union_type("LabelPrint.PdfGenerator.LogoCorner", [], LogoCorner, () => [[], [], [], []]);
}

export class TextAlign extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AlignLeft", "AlignCenter", "AlignRight"];
    }
}

export function TextAlign_$reflection() {
    return union_type("LabelPrint.PdfGenerator.TextAlign", [], TextAlign, () => [[], [], []]);
}

export class LabelData extends Record {
    constructor(Code, TextLine1, TextLine2) {
        super();
        this.Code = Code;
        this.TextLine1 = TextLine1;
        this.TextLine2 = TextLine2;
    }
}

export function LabelData_$reflection() {
    return record_type("LabelPrint.PdfGenerator.LabelData", [], LabelData, () => [["Code", string_type], ["TextLine1", string_type], ["TextLine2", string_type]]);
}

export class LabelConfig extends Record {
    constructor(CodeType, LabelWidth, LabelHeight, CodeSizeMm, ShowCode, ShowCodeValue, ShowText, TextLine1, TextLine2, ShowLogo, LogoDataUrl, Padding, LogoMaxHeight, LogoCorner, TextFontSize, TextAlign, CodeValueFontSize) {
        super();
        this.CodeType = CodeType;
        this.LabelWidth = LabelWidth;
        this.LabelHeight = LabelHeight;
        this.CodeSizeMm = CodeSizeMm;
        this.ShowCode = ShowCode;
        this.ShowCodeValue = ShowCodeValue;
        this.ShowText = ShowText;
        this.TextLine1 = TextLine1;
        this.TextLine2 = TextLine2;
        this.ShowLogo = ShowLogo;
        this.LogoDataUrl = LogoDataUrl;
        this.Padding = Padding;
        this.LogoMaxHeight = LogoMaxHeight;
        this.LogoCorner = LogoCorner;
        this.TextFontSize = TextFontSize;
        this.TextAlign = TextAlign;
        this.CodeValueFontSize = CodeValueFontSize;
    }
}

export function LabelConfig_$reflection() {
    return record_type("LabelPrint.PdfGenerator.LabelConfig", [], LabelConfig, () => [["CodeType", CodeType_$reflection()], ["LabelWidth", float64_type], ["LabelHeight", float64_type], ["CodeSizeMm", float64_type], ["ShowCode", bool_type], ["ShowCodeValue", bool_type], ["ShowText", bool_type], ["TextLine1", string_type], ["TextLine2", string_type], ["ShowLogo", bool_type], ["LogoDataUrl", option_type(string_type)], ["Padding", float64_type], ["LogoMaxHeight", float64_type], ["LogoCorner", LogoCorner_$reflection()], ["TextFontSize", float64_type], ["TextAlign", TextAlign_$reflection()], ["CodeValueFontSize", float64_type]]);
}

export function downloadTemplate() {
    const wb = xlsx.utils.book_new();
    const ws = xlsx.utils.aoa_to_sheet([["Code", "Zeile1", "Zeile2"]]);
    xlsx.utils.book_append_sheet(wb, ws, "Etiketten");
    xlsx.writeFile(wb, "etiketten-vorlage.xlsx");
}

export function parseExcelFile(file, onDone) {
    const reader = new FileReader();
    reader.onload = ((e) => {
        const result = e.target.result;
        const wb = xlsx.read(result, { type: 'array' });
        const sheetName = wb.SheetNames[0];
        const ws = wb.Sheets[sheetName];
        onDone(choose((row) => {
            const code = (row['Code'] || '').trim();
            if (code !== "") {
                return new LabelData(code, row['Zeile1'] || '', row['Zeile2'] || '');
            }
            else {
                return undefined;
            }
        }, ofArray(xlsx.utils.sheet_to_json(ws, { defval: '' }))));
    });
    reader.readAsArrayBuffer(file);
}

function computeMargins(cols, rows, labelW, labelH, hGap, vGap) {
    return [(210 - ((cols * labelW) + (max(0, cols - 1) * hGap))) / 2, (297 - ((rows * labelH) + (max(0, rows - 1) * vGap))) / 2];
}

function buildCodeCache(labels, codeType) {
    const canvas = document.createElement("canvas");
    const cache = new Map([]);
    iterate((code) => {
        const url = (codeType.tag === 1) ? ((function(lib, text, c){ c.width=600; c.height=200; try { lib(c, text, {format:'CODE128',width:2,height:160,displayValue:false,margin:0}); return c.toDataURL('image/png'); } catch(e){ return null; } })(jsbarcode, code, canvas)) : ((function(lib, text){ try { var qr = lib.create(text, { errorCorrectionLevel: 'M' }); var n = qr.modules.size; var data = Array.from(qr.modules.data); var s = 12; var c = document.createElement('canvas'); c.width = n * s; c.height = n * s; var ctx = c.getContext('2d'); ctx.imageSmoothingEnabled = false; ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, n * s, n * s); ctx.fillStyle = '#000'; for (var i = 0; i < n; i++) { for (var j = 0; j < n; j++) { if (data[i * n + j]) { ctx.fillRect(j * s, i * s, s, s); } } } return c.toDataURL('image/png'); } catch(e) { return null; } })(qrcode, code));
        if (!Operators_IsNull(url)) {
            cache.set(code, url);
        }
    }, List_distinct(map((l) => l.Code, labels), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
    return cache;
}

function drawLabel(doc, config, codeCache, label, x, y) {
    const p = config.Padding;
    const w = config.LabelWidth;
    const h = config.LabelHeight;
    doc.setFillColor(255, 255, 255);
    doc.rect(x, y, w, h, "F");
    let contentTop = y + p;
    if (config.ShowLogo) {
        const matchValue = config.LogoDataUrl;
        if (matchValue == null) {
        }
        else {
            const url = matchValue;
            const maxH = min(config.LogoMaxHeight, h * 0.4);
            const maxW = min(w - (2 * p), w * 0.5);
            let aspect;
            const a = (function(d, u){ try { var p = d.getImageProperties(u); return p.width / p.height; } catch(e){ return 0; } })(doc, url);
            aspect = ((a > 0) ? a : 3);
            let patternInput;
            const wByH = maxH * aspect;
            patternInput = ((wByH <= maxW) ? [wByH, maxH] : [maxW, maxW / aspect]);
            const logoW = patternInput[0];
            const logoH = patternInput[1];
            let patternInput_1;
            const matchValue_1 = config.LogoCorner;
            patternInput_1 = ((matchValue_1.tag === 1) ? [((x + w) - p) - logoW, y + p] : ((matchValue_1.tag === 2) ? [x + p, ((y + h) - p) - logoH] : ((matchValue_1.tag === 3) ? [((x + w) - p) - logoW, ((y + h) - p) - logoH] : [x + p, y + p])));
            doc.addImage(url, 'PNG', patternInput_1[0], patternInput_1[1], logoW, logoH);
        }
    }
    if (config.ShowCode) {
        const codeSize = max(3, min(config.CodeSizeMm, min(w - (2 * p), (h - (2 * p)) - (config.ShowText ? 5 : 0))));
        if (config.CodeType.tag === 1) {
            const barcodeH = codeSize * 0.5;
            let matchValue_4;
            let outArg_1 = defaultOf();
            matchValue_4 = [tryGetValue(codeCache, label.Code, new FSharpRef(() => outArg_1, (v_1) => {
                outArg_1 = v_1;
            })), outArg_1];
            if (matchValue_4[0]) {
                doc.addImage(matchValue_4[1], 'PNG', (x + p), contentTop, (w - (2 * p)), barcodeH);
            }
            else {
                doc.setFillColor(50, 50, 50);
                doc.rect((x + p), contentTop, (w - (2 * p)), (barcodeH * 0.8), "F");
            }
            contentTop = (contentTop + barcodeH);
        }
        else {
            let matchValue_3;
            let outArg = defaultOf();
            matchValue_3 = [tryGetValue(codeCache, label.Code, new FSharpRef(() => outArg, (v) => {
                outArg = v;
            })), outArg];
            if (matchValue_3[0]) {
                doc.addImage(matchValue_3[1], 'PNG', (x + p), contentTop, codeSize, codeSize);
            }
            contentTop = (contentTop + codeSize);
        }
        if (config.ShowCodeValue) {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(config.CodeValueFontSize);
            doc.setTextColor(0, 0, 0);
            const fontHeightMm = config.CodeValueFontSize * 0.353;
            const codeValueY = (contentTop + fontHeightMm) + 1;
            doc.text(label.Code, (x + p), codeValueY);
            contentTop = (codeValueY + 1.5);
        }
    }
    if (config.ShowText) {
        doc.setFontSize(config.TextFontSize);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(20, 20, 20);
        const lineH = config.TextFontSize * 0.6;
        const line1 = label.TextLine1.trim();
        const line2 = label.TextLine2.trim();
        const hasLine2 = line2 !== "";
        const textStartY = (((y + h) - p) - (hasLine2 ? (lineH * 2) : lineH)) + lineH;
        let textAlignStr;
        const matchValue_5 = config.TextAlign;
        textAlignStr = ((matchValue_5.tag === 1) ? "center" : ((matchValue_5.tag === 2) ? "right" : "left"));
        let textX;
        const matchValue_6 = config.TextAlign;
        textX = ((matchValue_6.tag === 1) ? (x + (w / 2)) : ((matchValue_6.tag === 2) ? ((x + w) - p) : (x + p)));
        if (line1 !== "") {
            doc.text(line1, textX, textStartY, { align: textAlignStr, maxWidth: (w - (2 * p)) });
        }
        if (hasLine2) {
            doc.text(line2, textX, (textStartY + lineH), { align: textAlignStr, maxWidth: (w - (2 * p)) });
        }
    }
}

function splitAtFirstDigit(s) {
    const idx = tryFindIndex(isDigit, s.split(""));
    if (idx != null) {
        const i = idx | 0;
        const prefix = s.slice(0, (i - 1) + 1);
        const numStr = s.slice(i, s.length);
        return [prefix, numStr, numStr.length];
    }
    else {
        return [s, "", 0];
    }
}

export function generateRangeCodes(fromCode, toCode) {
    const patternInput = splitAtFirstDigit(fromCode.trim());
    const patternInput_1 = splitAtFirstDigit(toCode.trim());
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(patternInput[1], 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
        outArg = (v | 0);
    })), outArg];
    let matchValue_1;
    let outArg_1 = 0;
    matchValue_1 = [tryParse(patternInput_1[1], 511, false, 32, new FSharpRef(() => (outArg_1 | 0), (v_1) => {
        outArg_1 = (v_1 | 0);
    })), outArg_1];
    let matchResult;
    if (matchValue[0]) {
        if (matchValue_1[0]) {
            if (matchValue_1[1] >= matchValue[1]) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return toList(delay(() => map_1((i) => (patternInput[0] + padLeft(int32ToString(i), patternInput[2], "0")), rangeDouble(matchValue[1], 1, matchValue_1[1]))));
        default:
            if (fromCode.trim() !== "") {
                return singleton(fromCode.trim());
            }
            else {
                return empty();
            }
    }
}

export function generate(labels, config, cols, rows, hGap, vGap) {
    if (isEmpty(labels)) {
    }
    else {
        const codeCache = config.ShowCode ? buildCodeCache(labels, config.CodeType) : (new Map([]));
        const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
        const perPage = (cols * rows) | 0;
        const patternInput = computeMargins(cols, rows, config.LabelWidth, config.LabelHeight, hGap, vGap);
        for (let i = 0; i <= (length(labels) - 1); i++) {
            const posOnPage = (i % perPage) | 0;
            if ((posOnPage === 0) && (i > 0)) {
                doc.addPage();
            }
            const x = patternInput[0] + ((posOnPage % cols) * (config.LabelWidth + hGap));
            const y = patternInput[1] + (~~(posOnPage / cols) * (config.LabelHeight + vGap));
            drawLabel(doc, config, codeCache, item(i, labels), x, y);
        }
        doc.save("etiketten.pdf");
    }
}

